import react from "react";
// import Tempapp from "./components/Tempapp";
import './App.css';
import Tempapp2 from "./components/Tempapp2";

function App() {
  return (
   <>
   {/* <Tempapp/> */}
   <Tempapp2/>
   </>
  );
}

export default App;
